import PhoneIcon from "@mui/icons-material/Phone";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { SxProps, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { primary } from "app/themes/colors";

type DigitButtonProps = {
  onClick?: (event: React.MouseEvent<any, MouseEvent>) => void;
  sx?: SxProps;
};
export default function CallButton({ sx, onClick }: DigitButtonProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        boxShadow: theme.shadows[3],
        px: 1,
        py: 0.5,
        borderRadius: "16px",
        background: primary[300],
        boxSizing: "border-box",
        width: "45px",
        height: "40px",
        cursor: onClick ? "pointer" : undefined,
        color: "white",
        "&:hover": {
          background: primary[400],
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <Stack
        width="100%"
        height="100%"
        sx={{
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
          }}
        >
          <PhoneIcon />
        </Typography>
      </Stack>
    </Box>
  );
}
